module.exports = "<div class=\"background-login\"></div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/login/login.component.html
// module id = ./src/app/pages/login/login.component.html
// module chunks = main